import React from 'react';
import Slider from "react-slick";
import { useState, useEffect, useRef  } from "react";

function Clients(){
    const settings = {
        dots: false,
        arrows:false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        autoplay: false,
        autoplaySpeed: 3000,
        responsive: [
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 2,
                dots: true,
                arrows:false,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 1,
                autoplay: true,
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                autoplay: true,
              }
            }
          ]
      };
      const settings2 = {
        slidesToShow: 3,
        slidesToScroll: 1,
        swipeToSlide:true,
        focusOnSelect:true,
        responsive: [
            {
              breakpoint: 1025,
              settings: {
                slidesToShow: 3,
                dots: true,
                arrows:false,
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2,
              
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 2,

              }
            }
          ]
      };
    const [nav1, setNav1] = useState(null);
    const [nav2, setNav2] = useState(null);
    let sliderRef1 = useRef(null);
    let sliderRef2 = useRef(null);
    useEffect(() => {
      setNav1(sliderRef1);
      setNav2(sliderRef2);
    }, []);
    return <>

<Slider className='happy-clients' asNavFor={nav2} ref={slider => (sliderRef1 = slider)} {...settings}>
        <div>
            <div className='CLientBox'>
                <div className='HeadingBox'>Client “Name Name 1”</div>
                <div className='Content'>
                    <img src={require('../../images/c1.webp')} alt='client 1'/>
                    <p>“digital heroes made an awesome job!<br/> they designed and programmed the whole page and since ive got a ton new clients because digital heroes made the very best page everybody had ever seen! recommend 10/10 stars!”</p>
                </div>
            </div>
        </div>

        <div>
            <div className='CLientBox'>
                <div className='HeadingBox'>Client “Name Name 2”</div>
                <div className='Content'>
                    <img src={require('../../images/c2.webp')} alt='client 1'/>
                    <p>“digital heroes made an awesome job!<br/> they designed and programmed the whole page and since ive got a ton new clients because digital heroes made the very best page everybody had ever seen! recommend 10/10 stars!”</p>
                </div>
            </div>
        </div>

        <div>
            <div className='CLientBox'>
                <div className='HeadingBox'>Client “Name Name 3”</div>
                <div className='Content'>
                    <img src={require('../../images/c1.webp')} alt='client 1'/>
                    <p>“digital heroes made an awesome job!<br/> they designed and programmed the whole page and since ive got a ton new clients because digital heroes made the very best page everybody had ever seen! recommend 10/10 stars!”</p>
                </div>
            </div>
        </div>
      </Slider>
      <div className='CenterText'>Do you want to see more? Just chose from below <br/>or browse our Client history</div>
      <Slider className="thumb-wrapper happy-clients" asNavFor={nav1} ref={slider => (sliderRef2 = slider)} {...settings2}>
            <div>
                <div className='CLientBox'>
                    <div className='HeadingBox'>Client “Name Name 1”</div>
                    <div className='Content'>
                        <img src={require('../../images/c1.webp')} alt='client 1'/>
                    </div>
                </div>
            </div>

            <div>
                <div className='CLientBox'>
                    <div className='HeadingBox'>Client “Name Name 2”</div>
                    <div className='Content'>
                        <img src={require('../../images/c2.webp')} alt='client 1'/>
                    </div>
                </div>
            </div>
            
            <div>
                <div className='CLientBox'>
                    <div className='HeadingBox'>Client “Name Name 3”</div>
                    <div className='Content'>
                        <img src={require('../../images/c1.webp')} alt='client 1'/>
                    </div>
                </div>
            </div>
    </Slider>
    </>
}
export default Clients;